import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';
import { EMPTY_GUID_REGEX } from '../../constants/system-constants.model';

export const GuidHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    map(event => {
      if (event instanceof HttpResponse) {
        const modifiedBody = replaceGuidWithNull(event.body);
        return event.clone({ body: modifiedBody });
      }
      return event;
    })
  );
};

function replaceGuidWithNull<T>(data: T): T {
  if (data !== null && typeof data === 'object') {
    const obj = data as Record<string, unknown>;
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        if (typeof value === 'string' && EMPTY_GUID_REGEX.test(value))
          obj[key] = null;
        else if (typeof value === 'object')
          obj[key] = replaceGuidWithNull(value);
      }
    }
  }
  return data;
}